module.exports = __webpack_public_path__ + "media/images/exit-adcb276fee2e608c88333cb72504d733.svg";